import styled from '@emotion/styled';
import { breakpoints, getClampFullRange } from '~/theme';

export const StyledReserveSectionForm = styled.div(({ theme }) => ({
    display: 'grid',
    gap: theme.spaces[4],
    padding: `${getClampFullRange(theme.spacesRaw[3], theme.spacesRaw[4])} 0`,

    [breakpoints.sm]: {
        gridTemplateColumns: '1fr 1fr',
    },
}));
